import { useGetTjenesteTeksterQuery } from '@helsenorge/framework-utils/cms-tjeneste-tekster';
import { selectCurrentLanguage } from '@helsenorge/framework-utils/language';
import useCustomHjelpetekst from './useCustomHjelpetekst';
import { useAppSelector } from '../../../store/hooks';
/**
 * Hent hjelpetekst for en tjeneste
 * @param tjenesteNavn Navn på tjenesten
 */
const useHjelpetekst = (tjenesteNavn) => {
    const language = useAppSelector(state => selectCurrentLanguage(state.language));
    const { data, isLoading, isError } = useGetTjenesteTeksterQuery({
        navn: tjenesteNavn,
        languageCode: language,
    });
    const customHjelpetekst = useCustomHjelpetekst(tjenesteNavn);
    if (customHjelpetekst?.hjelpeskuffTittel && customHjelpetekst?.hjelpeskuffTekst) {
        return {
            hjelpeskuffTittel: customHjelpetekst.hjelpeskuffTittel,
            hjelpeskuffTekst: customHjelpetekst.hjelpeskuffTekst,
            isLoading: false,
            isError: false,
        };
    }
    const { hjelpeskuffTittel, hjelpeskuffTekst } = data?.hjelpetekster || { hjelpeskuffTittel: '', hjelpeskuffTekst: [] };
    return {
        hjelpeskuffTittel,
        hjelpeskuffTekst,
        isLoading,
        isError,
    };
};
export default useHjelpetekst;
